import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#12324A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <div className="flex items-center space-x-2 mb-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_26db3989-351b-4ced-8734-bc1c3085c5e6/artifacts/5iwgquk9_ChatGPT%20Image%20TouchscreenMD%20Original%20Logo%20Telehealth.png" 
                  alt="TouchScreenMD" 
                  className="h-12 w-auto brightness-0 invert"
                />
                <div className="flex flex-col">
                  <div className="text-lg font-bold">
                    <span className="text-gray-300">TouchScreen</span>
                    <span className="text-white">MD</span>
                    <span className="text-[#8FB6E0]">.com</span>
                  </div>
                  <div className="text-xs text-gray-400 leading-tight">
                    Revolutionizing Healthcare
                  </div>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-300 mb-4">
              Secure telehealth visits with licensed providers. Get care anytime, anywhere.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <MapPin size={16} className="text-[#1FB6B2]" />
                <span>United States</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Mail size={16} className="text-[#1FB6B2]" />
                <span>support@touchscreenmd.com</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Phone size={16} className="text-[#1FB6B2]" />
                <span>1-800-TOUCH-MD</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/how-it-works" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  How it Works
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/insurance" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  Insurance & Medicaid
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/npp" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  Notice of Privacy Practices
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  For Providers
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-[#1FB6B2] transition-colors">
                  For Employers
                </a>
              </li>
            </ul>
          </div>

          {/* Get Started */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Get Started</h3>
            <p className="text-sm text-gray-300 mb-4">
              Ready to connect with a licensed provider?
            </p>
            <Link
              to="/start-visit"
              className="inline-block px-6 py-3 bg-[#1FB6B2] hover:bg-[#1a9d99] text-white font-medium rounded-lg transition-all duration-200"
            >
              Start a Visit Now
            </Link>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} TouchScreenMD®. All rights reserved.
            </p>
            <p className="text-xs text-gray-400 text-center md:text-right max-w-2xl">
              TouchScreenMD provides access to telehealth services from licensed providers. Not for emergencies—call 911. Individual results vary. Coverage and copays vary by plan and state.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
